<div [ngClass]="[!isSmallView ? 'width-100' : 'sm-container']">
    <div class="layout small-gap">
        <div class="brd-crmb">
            <a (click)="clickAction()">{{sourceName}}</a> > {{formName}} 
        </div>
        <div class="header-text no-border layout_one_up_center">
            USAN Application for {{formName}} - Form {{formType}} <span *ngIf="isFormLocked" class="locked-msg-cls" matTooltip ="Another user is currently editing the application"> (Read-only)</span>
        </div>
    
        <div *ngIf="!loadingComplete || !caseUpdateComplete" class="spinner-div gbl-div">
            <mat-spinner class="spinner-cls gbl-cls"></mat-spinner>
        </div>
        <div class="detail-container" *ngIf="showResults">
            <div *ngIf="isSmallView" class="detail-sm-container no-top-margin">
                <div class="width-100">
                    <div class="sub-item-header sub-details">File Number</div>
                    <div *ngIf="!isUsanAdmin" class= "text-content-detail-body">{{data.fileNumber}}</div>
                    <div *ngIf="isUsanAdmin">
                        <mat-form-field *ngIf="!fileNumberEdit"> 
                            <input matInput [value]="[data.fileNumber? data.fileNumber: 'Enter File Number']" readonly>
                        </mat-form-field>
                        <mat-form-field *ngIf="fileNumberEdit">
                             <input matInput [(ngModel)]="selectedFileNumber" [disabled]="isFormLocked">
                        </mat-form-field>
                        <span class="padding-left-10">
                            <button class="bgcolor-white user-name-edit" aria-label="Edit" *ngIf="!fileNumberEdit" (click)="enableCaseEdit('fileNumber')" [disabled]="isFormLocked">
                                <mat-icon>{{ isFormLocked ? 'lock' : 'edit' }}</mat-icon>
                            </button>
                            <button class="bgcolor-white user-name-edit" aria-label="Save" *ngIf="fileNumberEdit" (click)="updateCase('fileNumber')" [disabled]="disableEditFileNumber('fileNumber')">
                                <mat-icon>check</mat-icon>
                            </button>
                            <button class="bgcolor-white user-name-edit" aria-label="Cancel" *ngIf="fileNumberEdit" (click)="cancelCaseFieldSelection('fileNumber')">
                                <mat-icon>cancel</mat-icon>
                            </button>
                        </span>
                    </div>
                </div>
                <div *ngIf="formType === 'A'"  class="width-100">
                    <div class="sub-item-header sub-details">File Number Modified</div>
                    <div *ngIf="!isUsanAdmin" class= "text-content-detail-body">{{data.fileNumberModified}}</div>
                    <div *ngIf="isUsanAdmin">
                        <mat-form-field *ngIf="!fileNumberEditMod"> 
                            <input matInput [value]="[data.fileNumberModified? data.fileNumberModified: 'Enter File Number Modified']" readonly>
                        </mat-form-field>
                        <mat-form-field *ngIf="fileNumberEditMod">
                             <input matInput [(ngModel)]="selectedFileNumberMod" [disabled]="isFormLocked">
                        </mat-form-field>
                        <span class="padding-left-10">
                            <button class="bgcolor-white user-name-edit" aria-label="Edit" *ngIf="!fileNumberEditMod" (click)="enableCaseEdit('fileNumberMod')" [disabled]="isFormLocked">
                                <mat-icon>{{ isFormLocked ? 'lock' : 'edit' }}</mat-icon>
                            </button>
                            <button class="bgcolor-white user-name-edit" aria-label="Save" *ngIf="fileNumberEditMod" (click)="updateCase('fileNumberMod')" [disabled]="disableEditFileNumber('fileNumberMod')">
                                <mat-icon>check</mat-icon>
                            </button>
                            <button class="bgcolor-white user-name-edit" aria-label="Cancel" *ngIf="fileNumberEditMod" (click)="cancelCaseFieldSelection('fileNumberMod')">
                                <mat-icon>cancel</mat-icon>
                            </button>
                        </span>
                    </div>
                </div>
                <div class="width-100">
                    <div class="sub-item-header sub-details">Case Number</div>
                    <div class= "text-content-detail-body">{{caseNumber}}</div>
                </div>
                <div class="width-100">
                    <div class="sub-item-header sub-details">Case Status</div>
                    <div *ngIf="!isUsanAdmin || !updateStatusListMap[data.caseStatus]" class= "text-content-detail-body">{{data.caseStatus}}</div>
                    <div *ngIf="isUsanAdmin && updateStatusListMap[data.caseStatus]" class="user-selection-action">
                        <mat-form-field *ngIf="!allowCaseStatusUpdate || isFormLocked"> 
                            <input matInput [value]="[data.caseStatus]" readonly>
                        </mat-form-field>
                        <mat-form-field *ngIf="allowCaseStatusUpdate && !isFormLocked">
                            <mat-label>Select Status</mat-label>
                            <mat-select [(value)]="selectedCaseStatus" class="user-name-input">
                                <ng-container  *ngFor="let status of updateStatusListMap[data.caseStatus]">
                                <mat-option [value]="status" >{{ status }}</mat-option>
                                </ng-container>
                            </mat-select>
                        </mat-form-field>
                        <span class="padding-left-10 user-selection-action">
                            <button class="bgcolor-white user-name-edit" aria-label="Edit Status" *ngIf="!allowCaseStatusUpdate && updateStatusListMap[data.caseStatus]" (click)="openStatusSelection()" [disabled]="isFormLocked">
                                <mat-icon>{{ isFormLocked ? 'lock' : 'edit' }}</mat-icon>
                            </button>
                            <button class="bgcolor-white user-name-edit" aria-label="Save Status" *ngIf="allowCaseStatusUpdate" (click)="updateCaseStatus()">
                                <mat-icon>check</mat-icon>
                            </button>
                            <button class="bgcolor-white user-name-edit" aria-label="Cancel" *ngIf="allowCaseStatusUpdate" (click)="cancelStatusSelection()">
                                <mat-icon>cancel</mat-icon>
                            </button>
                        </span>
                    </div>
                </div>
                <div class="width-100" *ngIf="data.caseStatus ==='Approved' || data.caseStatus ==='Closed'"> 
                    <div class="sub-item-header sub-details">Final Adopted Name</div>
                    <div class= "text-content-detail-body" *ngIf="data.caseStatus ==='Closed' || !isUsanAdmin">
                        {{data.finalAdoptedName}}
                    </div>
                    <div class="user-selection-action" *ngIf="data.caseStatus ==='Approved' && isUsanAdmin">
                        <mat-form-field *ngIf="!finalAdoptedNameEdit"> 
                            <input matInput [value]="[data.finalAdoptedName]" readonly>
                        </mat-form-field>
                        <mat-form-field *ngIf="finalAdoptedNameEdit">
                             <input matInput [(ngModel)]="selectedFinalAdoptedName" [disabled]="isFormLocked">
                        </mat-form-field>
                        <span class="padding-left-10 user-selection-action">
                            <button class="bgcolor-white user-name-edit" aria-label="Edit" *ngIf="!finalAdoptedNameEdit" (click)="enableCaseEdit('finalAdoptedName')" [disabled]="isFormLocked">
                                <mat-icon>{{ isFormLocked ? 'lock' : 'edit' }}</mat-icon>
                            </button>
                            <button class="bgcolor-white user-name-edit" aria-label="Save" *ngIf="finalAdoptedNameEdit" (click)="updateCase('finalAdoptedName')" [disabled]="disableFinalAdoptedNameEdit()">
                                <mat-icon>check</mat-icon>
                            </button>
                            <button class="bgcolor-white user-name-edit" aria-label="Cancel" *ngIf="finalAdoptedNameEdit" (click)="cancelCaseFieldSelection('finalAdoptedName')">
                                <mat-icon>cancel</mat-icon>
                            </button>
                        </span>
                    </div>
                </div>
                <div class="width-100" *ngIf="formType === 'A' && (data.caseStatus ==='Approved' || data.caseStatus ==='Closed')"> 
                    <div class="sub-item-header sub-details">Final Adopted Name - Modified</div>
                    <div class= "text-content-detail-body" *ngIf="data.caseStatus ==='Closed' || !isUsanAdmin">
                        {{data.finalAdoptedNameMod}}
                    </div>
                    <div class="user-selection-action" *ngIf="data.caseStatus ==='Approved' && isUsanAdmin">
                        <mat-form-field *ngIf="!finalAdoptedNameModEdit"> 
                            <input matInput [value]="[data.finalAdoptedNameMod]" readonly>
                        </mat-form-field>
                        <mat-form-field *ngIf="finalAdoptedNameModEdit">
                             <input matInput [(ngModel)]="selectedFinalAdoptedNameMod" [disabled]="isFormLocked">
                        </mat-form-field>
                        <span class="padding-left-10 user-selection-action">
                            <button class="bgcolor-white user-name-edit" aria-label="Edit" *ngIf="!finalAdoptedNameModEdit" (click)="enableCaseEdit('finalAdoptedNameMod')" [disabled]="isFormLocked">
                                <mat-icon>{{ isFormLocked ? 'lock' : 'edit' }}</mat-icon>
                            </button>
                            <button class="bgcolor-white user-name-edit" aria-label="Save" *ngIf="finalAdoptedNameModEdit" (click)="updateCase('finalAdoptedNameMod')" [disabled]="disableFinalAdoptedNameModEdit()">
                                <mat-icon>check</mat-icon>
                            </button>
                            <button class="bgcolor-white user-name-edit" aria-label="Cancel" *ngIf="finalAdoptedNameModEdit" (click)="cancelCaseFieldSelection('finalAdoptedNameMod')">
                                <mat-icon>cancel</mat-icon>
                            </button>
                        </span>
                    </div>
                </div>
                <div class="width-100" *ngIf="data.caseStatus ==='Approved' || data.caseStatus ==='Closed'">
                    <div class="sub-item-header sub-details">Date Name Adopted or Closed</div>
                    <div *ngIf="!isUsanAdmin" class= "text-content-detail-body">{{this.data.adoptedOrClosedDate | date: 'MMMM d, y'}}</div>
                    <div *ngIf="isUsanAdmin" class="user-selection-action">
                        <mat-form-field>
                            <input matInput [matDatepicker]="picker" (dateChange)="selectAdoptedOrClosedDate($event.value)" [value]="adoptedOrClosedDate" [disabled]="isFormLocked">
                            <mat-datepicker-toggle  matIconSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>
                        </mat-form-field>
                        <span class="padding-left-10 user-selection-action">
                            <button class="bgcolor-white user-name-edit" aria-label="Save" (click)="updateCase('adoptedOrClosedDate')" [disabled]="disableAdoptedOrClosedDate()">
                                <mat-icon>{{ isFormLocked ? 'lock' : 'check' }}</mat-icon>
                            </button>
                        </span>
                    </div>
                </div>
                <div class="width-100">
                    <div class="sub-item-header sub-details">Payment Status</div>
                    <div class= "text-content-detail-body">{{paymentStatus}}</div>
                    <div class= "payment-container" *ngIf="paymentStatus !== 'Completed' && !isViewOnly">
                        <button aria-label="Save comments icon" class="save-btn-cls width-100 blue-background" (click)="openPaymentModal()" [disabled]="isFormLocked">
                            <mat-icon>save</mat-icon><span class="save-btn-lbl">Add Payment</span> 
                        </button>
                    </div>
                </div>
                <div class="width-100" *ngIf="paymentStatus === 'Completed'">
                    <div class="sub-item-header sub-details">Payment Type</div>
                    <div class= "text-content-detail-body">{{data.paymentType}}</div>
                </div>
                <div class="width-100" *ngIf="data.paymentType ==='ACH'">
                    <div class="sub-item-header sub-details">ACH Transaction ID</div>
                    <div class= "text-content-detail-body wrap-break">{{data.paymentDetails}}</div>
                </div>
                <div class="width-100" *ngIf="data.paymentType ==='WIRE' && isUsanAdmin"> 
                    <div class="sub-item-header sub-details">CR#</div>
                    <div class="user-selection-action">
                        <mat-form-field *ngIf="!cashReceiptNumberEdit"> 
                            <input matInput [value]="[data.cashReceiptNumber? data.cashReceiptNumber: 'Enter Cash Receipt #']" readonly>
                        </mat-form-field>
                        <mat-form-field *ngIf="cashReceiptNumberEdit">
                             <input matInput [(ngModel)]="selectedCashReceiptNumber" [disabled]="isFormLocked">
                        </mat-form-field>
                        <span class="padding-left-10 user-selection-action">
                            <button class="bgcolor-white user-name-edit" aria-label="Edit" *ngIf="!cashReceiptNumberEdit" (click)="enableCaseEdit('cashReceiptNumber')" [disabled]="isFormLocked">
                                <mat-icon>{{ isFormLocked ? 'lock' : 'edit' }}</mat-icon>
                            </button>
                            <button class="bgcolor-white user-name-edit" aria-label="Save" *ngIf="cashReceiptNumberEdit" (click)="updateCase('cashReceiptNumber')" [disabled]="disableCashReceiptNumberEdit()">
                                <mat-icon>check</mat-icon>
                            </button>
                            <button class="bgcolor-white user-name-edit" aria-label="Cancel" *ngIf="cashReceiptNumberEdit" (click)="cancelCaseFieldSelection('cashReceiptNumber')">
                                <mat-icon>cancel</mat-icon>
                            </button>
                        </span>
                    </div>
                </div>
                <div class="width-100">
                    <div class="sub-item-header sub-details">Payment Date</div>
                    <div *ngIf="!isUsanAdmin" class= "text-content-detail-body">{{this.data.paymentReceivedDate | date: 'MMMM d, y'}}</div>
                    <div *ngIf="isUsanAdmin" class="user-selection-action">
                        <mat-form-field>
                            <input matInput [matDatepicker]="picker" (dateChange)="selectPaymentDate($event.value)" [value]="paymentReceivedDate" [disabled]="isFormLocked"> <!--   [value]="data.paymentReceivedDate" -->
                            <mat-datepicker-toggle  matIconSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>
                        </mat-form-field>
                        <span class="padding-left-10 user-selection-action">
                            <button class="bgcolor-white user-name-edit" aria-label="Save" (click)="updateCase('paymentDate')" [disabled]="disablePaymentDateEdit()">
                                <mat-icon>{{ isFormLocked ? 'lock' : 'check' }}</mat-icon>
                            </button>
                        </span>
                    </div>
                </div>
                <div class="width-100">
                    <div class="sub-item-header sub-details">Negotiator</div>
                    <div *ngIf="!isUsanAdmin" class= "text-content-detail-body">{{data.negotiator}}</div>
                    <div *ngIf="isUsanAdmin">
                        <mat-form-field *ngIf="!showNegotiators"> 
                            <input matInput [value]="[data.negotiator? data.negotiator: 'Assign Negotiator']" readonly>
                        </mat-form-field>
                        <span class="padding-left-10">
                            <button class="bgcolor-white user-name-edit" aria-label="Edit Negotiator" *ngIf="!showNegotiators" (click)="openNegotiatorSelection()" [disabled]="isFormLocked">
                                <mat-icon>{{ isFormLocked ? 'lock' : 'edit' }}</mat-icon>
                            </button>
                        </span>
                    </div>
                </div>
                <div class="full-width">
                    <div class="sub-item-header sub-details padding-bottom-0">USAN User</div>
                    <div *ngIf="!isOrgAdmin" class= "text-content-detail-body">{{data.usanUserName}}</div>
                    <div *ngIf="isOrgAdmin">
                        <mat-form-field *ngIf="!showUsers"> 
                            <input matInput [value]="[data.usanUserName? data.usanUserName: 'Assign User']" readonly>
                        </mat-form-field>
                        <mat-form-field *ngIf="showUsers && usersLoadingComplete" [disabled]="isFormLocked">
                            <mat-label>Select User</mat-label>
                            <mat-select [(value)]="selectedUser" class="user-name-input">
                                <ng-container  *ngFor="let user of usersList">
                                <mat-option [value]="user" >{{ user.userName }}</mat-option>
                                </ng-container>
                            </mat-select>
                        </mat-form-field>
                        <span class="padding-left-10">
                            <button class="bgcolor-white user-name-edit" aria-label="Edit User" *ngIf="!showUsers"  [disabled]="isFormLocked"> <!-- (click)="openUserSelection()"-->
                            <mat-icon>{{ isFormLocked ? 'lock' : 'edit' }}</mat-icon>
                            </button>
                            <button class="bgcolor-white user-name-edit" aria-label="Save User" *ngIf="showUsers" (click)="addUserToApplication()" [disabled]="disableUpdateButton()">
                                <mat-icon>check</mat-icon>
                            </button>
                            <button class="bgcolor-white user-name-edit" aria-label="Cancel" *ngIf="showUsers" (click)="cancelUserSelection()">
                                <mat-icon>cancel</mat-icon>
                            </button>
                        </span>
                    </div>
                </div>
                <div class="full-width">
                    <div class="sub-item-header sub-details padding-bottom-0">Application Collaborator 1</div>
                    <div *ngIf="!isOrgAdmin" class= "text-content-detail-body">{{data.collaborator1}}</div>
                    <div *ngIf="isOrgAdmin">
                        <mat-form-field *ngIf="!showCollab1 || isFormLocked"> 
                            <input matInput [value]="[data.collaborator1? data.collaborator1: 'Assign Collaborator']" readonly>
                        </mat-form-field>
                        <mat-form-field *ngIf="showCollab1 && usersLoadingComplete && !isFormLocked">
                            <mat-select [(value)]="selectedCollaborator1" class="user-name-input">
                                <ng-container  *ngFor="let user of applicantsList">
                                <mat-option [value]="user" >{{ user.userName }}</mat-option>
                                </ng-container>
                            </mat-select>
                        </mat-form-field>
                        <span class="padding-left-10">
                            <button class="bgcolor-white user-name-edit" aria-label="Edit User" *ngIf="!showCollab1" (click)="openUserSelection('collab1')"> 
                                <mat-icon>{{ isFormLocked ? 'lock' : 'edit' }}</mat-icon>
                            </button>
                            <button class="bgcolor-white user-name-edit" aria-label="Save User" *ngIf="showCollab1" (click)="addUserToApplication('collab1')" [disabled]="disableUpdateCollabButton('collab1')">
                                <mat-icon>check</mat-icon>
                            </button>
                            <button class="bgcolor-white user-name-edit" aria-label="Cancel" *ngIf="showCollab1" (click)="cancelUserSelection('collab1')">
                                <mat-icon>cancel</mat-icon>
                            </button>
                        </span>
                    </div>
                </div>
                <div class="full-width">
                    <div class="sub-item-header sub-details padding-bottom-0">Application Collaborator 2</div>
                    <div *ngIf="!isOrgAdmin" class= "text-content-detail-body">{{data.collaborator2}}</div>
                    <div *ngIf="isOrgAdmin">
                        <mat-form-field *ngIf="!showCollab2 || isFormLockedk"> 
                            <input matInput [value]="[data.collaborator2? data.collaborator2: 'Assign Collaborator']" readonly>
                        </mat-form-field>
                        <mat-form-field *ngIf="showCollab2 && usersLoadingComplete && !isFormLocked">
                            <mat-select [(value)]="selectedCollaborator2" class="user-name-input">
                                <ng-container  *ngFor="let user of applicantsList">
                                <mat-option [value]="user" >{{ user.userName }}</mat-option>
                                </ng-container>
                            </mat-select>
                        </mat-form-field>
                        <span class="padding-left-10">
                            <button class="bgcolor-white user-name-edit" aria-label="Edit User" *ngIf="!showCollab2" (click)="openUserSelection('collab2')"> 
                                <mat-icon>{{ isFormLocked ? 'lock' : 'edit' }}</mat-icon>
                            </button>
                            <button class="bgcolor-white user-name-edit" aria-label="Save User" *ngIf="showCollab2" (click)="addUserToApplication('collab2')" [disabled]="disableUpdateCollabButton('collab2')">
                                <mat-icon>check</mat-icon>
                            </button>
                            <button class="bgcolor-white user-name-edit" aria-label="Cancel" *ngIf="showCollab2" (click)="cancelUserSelection('collab2')">
                                <mat-icon>cancel</mat-icon>
                            </button>
                        </span>
                    </div>
                </div>
                <div class="width-100">
                    <div class="sub-item-header sub-details">Submitted Date</div>
                    <div class= "text-content-detail-body">{{data.submittedDate | date: 'MMMM d, y'}}</div>
                </div>
                <div class="width-100">
                    <div class="sub-item-header sub-details">Latest Comment</div>
                    <div class= "text-content-detail-body">{{latestComment}}</div>
                    <div *ngIf="hasComments" class="prior-cls">
                        <a (click)="displayPriorComments()">Prior Comments</a>
                    </div>
                </div>
                <div class="width-100" *ngIf="!isViewOnly">
                    <div >
                        <mat-form-field class="comments-text-cls">
                            <textarea matInput  placeholder="Add New Comments" [(ngModel)]="newComments" maxlength="255" [disabled]="isFormLocked"></textarea> 
                        </mat-form-field>
                    </div>
                    <div>
                        <button aria-label="Save comments icon" class="save-btn-cls width-100 blue-background" (click)="saveComments()" [disabled]="isFormLocked">
                            <mat-icon>save</mat-icon><span class="save-btn-lbl">Save Comments</span> 
                        </button>
                    </div>
                </div>
            </div>
            <div [ngClass]="[!isSmallView ? 'detail-left-container': 'detail-sm-container']"> 
                <div class="width-100">
                <div class="sub-header">
                    Substance Information
                </div>
                <span class="upload-btn-div" *ngIf="accessToEdit">
                    <button aria-label="Edit icon" [ngClass]="[!isSmallView ? 'upload-btn-cls btn-wdth':'upload-btn-cls btn-wdth-sm']" (click)="displayEditFields()" [disabled]="isFormLocked">
                        <span class="save-btn-lbl">Edit</span> 
                    </button>
                </span>
                </div>
                <div [ngClass]="{'full-width': !isSmallView}"> 
                    <div [ngClass]="{'half-width': !isSmallView}" *ngIf="formType != 'D'">
                        <div class="sub-item-header">Suggested name(s) in order of preference</div>
                        <div class= "text-content-detail-body" *ngIf="data.firstSuggestedName.includes(',')">
                            <ol type="1" class="list-items" >
                                <li *ngFor="let name of splitList(data.firstSuggestedName)">{{name}}</li>
                            </ol>
                        </div>
                        <div class= "text-content-detail-body" *ngIf="!data.firstSuggestedName.includes(',')"> {{data.firstSuggestedName}} </div>
                    </div>
                    <div [ngClass]="{'half-width': !isSmallView}" *ngIf="formType === 'A'">
                        <div class="sub-item-header">Designation for Salt Form</div>
                        <div class= "text-content-detail-body">{{data.designationForSalt}}</div>
                    </div>
                    <div [ngClass]="{'half-width': !isSmallView}" *ngIf="('B,C,E').includes(formType)"> 
                        <div class="sub-item-header">Chemical Name(s) or Description</div>
                        <div class= "text-content-detail-body">{{data.chemName}}</div>
                    </div>
                    <div [ngClass]="{'half-width': !isSmallView}" *ngIf="formType === 'D'">
                        <div class="sub-item-header">Name for which you are requesting a Revision</div>
                        <div class= "text-content-detail-body">{{data.revisionName}}</div>
                    </div>
                    <div [ngClass]="{'half-width': !isSmallView}" *ngIf="formType === 'D'">
                        <div class="sub-item-header">Reason for Revision</div>
                        <div class= "text-content-detail-body">{{data.revisionReason}}</div>
                    </div>
                    <div [ngClass]="{'half-width': !isSmallView}" *ngIf="formType === 'F'">
                        <div class="sub-item-header">Systematic Name(s) or Description</div>
                        <div class= "text-content-detail-body">{{data.systematicName}}</div>
                    </div>
                </div>
                <div [ngClass]="{'full-width': !isSmallView}" *ngIf="formType === 'A'">
                    <div [ngClass]="{'half-width': !isSmallView}">
                        <div class="sub-item-header">Chemical Name(s) or Description for Single Entity</div>
                        <div class= "text-content-detail-body">{{data.chemNameForEntity}}</div>
                    </div>
                    <div [ngClass]="{'half-width': !isSmallView}">
                        <div class="sub-item-header">Chemical Name(s) or Description for Salt Form</div>
                        <div class= "text-content-detail-body">{{data.chemNameForSalt}}</div>
                    </div>
                </div>
                <div [ngClass]="{'full-width': !isSmallView}" *ngIf="formType === 'A'">
                    <div [ngClass]="{'half-width': !isSmallView}">
                        <div class="sub-item-header">Molecular Formula for Single Entity</div>
                        <div class= "text-content-detail-body">{{data.molecularFormulaForEntity}}</div>
                    </div>
                    <div [ngClass]="{'half-width': !isSmallView}">
                        <div class="sub-item-header">Molecular Formula for Salt Form</div>
                        <div class= "text-content-detail-body">{{data.molecularFormulaForSalt}}</div>
                    </div>
                </div>
                <div [ngClass]="{'full-width': !isSmallView}" *ngIf="('B,C,D,F').includes(formType)">
                    <div [ngClass]="{'half-width': !isSmallView}">
                        <div class="sub-item-header">Molecular Formula</div>
                        <div class= "text-content-detail-body">{{data.molecularFormula}}</div>
                    </div>
                    <div [ngClass]="{'half-width': !isSmallView}">
                        <div class="sub-item-header">Molecular Weight</div>
                        <div class= "text-content-detail-body">{{data.molecularWeight}}</div>
                    </div>
                </div>
                <div [ngClass]="{'full-width': !isSmallView}" *ngIf="formType === 'A'">
                    <div [ngClass]="{'half-width': !isSmallView}">
                        <div class="sub-item-header">Molecular Weight for Single Entity</div>
                        <div class= "text-content-detail-body">{{data.molecularWeightForEntity}}</div>
                    </div>
                    <div [ngClass]="{'half-width': !isSmallView}">
                        <div class="sub-item-header">Molecular Weight for Salt Form</div>
                        <div class= "text-content-detail-body">{{data.molecularWeightForSalt}}</div>
                    </div>
                </div>
                <div [ngClass]="{'full-width': !isSmallView}" *ngIf="('A,B,C,D,F').includes(formType)">
                    <div [ngClass]="{'half-width': !isSmallView}" *ngIf="('A,B').includes(formType)">
                        <div class="sub-item-header">Is this a Pro Drug</div>
                        <div class= "text-content-detail-body">{{data.isProdDrug}}</div>
                    </div>
                    <div [ngClass]="{'half-width': !isSmallView}" *ngIf="formType === 'D'">
                        <div class="sub-item-header">Chemical Name(s) or Description</div>
                        <div class= "text-content-detail-body">{{data.chemName}}</div>
                    </div>
                    <div [ngClass]="{'half-width': !isSmallView}" *ngIf="('B,C,D,F').includes(formType)">
                        <div class="sub-item-header">Chemical Abstracts Service (CAS) Registry Number</div>
                        <div class= "text-content-detail-body">{{data.casRegistryNumber}}</div>
                    </div>
                    <div [ngClass]="{'half-width': !isSmallView}" *ngIf="formType === 'F'">
                        <div class="sub-item-header">Unique Ingredient Identifier (UNII) Number</div>
                        <div class= "text-content-detail-body">{{data.uniiNumber}}</div>
                    </div>
                </div>
                <div [ngClass]="{'full-width': !isSmallView}" *ngIf="formType === 'A'">
                    <div [ngClass]="{'half-width': !isSmallView}">
                        <div class="sub-item-header">Chemical Abstracts Service (CAS) Registry Number for Single Entity</div>
                        <div class= "text-content-detail-body">{{data.casRegistryForEntity}}</div>
                    </div>
                    <div [ngClass]="{'half-width': !isSmallView}">
                        <div class="sub-item-header">Chemical Abstracts Service (CAS) Registry Number for Salt Form</div>
                        <div class= "text-content-detail-body">{{data.casRegistryForSalt}}</div>
                    </div>
                </div>
                <div [ngClass]="{'full-width': !isSmallView}" *ngIf="formType === 'B'">
                    <div [ngClass]="{'half-width': !isSmallView}">
                        <div class="sub-item-header">Unique Ingredient Identifier (UNII) Number</div>
                        <div class= "text-content-detail-body">{{data.uniiNumber}}</div>
                    </div>
                    <!--<div [ngClass]="{'half-width': !isSmallView}">
                        <div class="sub-item-header">Unique Ingredient Identifier (UNII) Number (SALT)</div>
                        <div>{{data.uniiNumberSalt}}</div>
                    </div> -->
                </div>
                <div [ngClass]="{'full-width': !isSmallView}" *ngIf="formType === 'A'">
                    <div [ngClass]="{'half-width': !isSmallView}">
                        <div class="sub-item-header">Code Designation(s) for Single Entity</div>
                        <div class= "text-content-detail-body">{{data.codeDesignationForEntity}}</div>
                    </div>
                    <div [ngClass]="{'half-width': !isSmallView}">
                        <div class="sub-item-header">Code Designation(s) for Salt Form</div>
                        <div class= "text-content-detail-body">{{data.codeDesignationForSalt}}</div>
                    </div>
                </div>
                <div [ngClass]="{'full-width': !isSmallView}" *ngIf="('C,D').includes(formType)">
                    <div [ngClass]="{'half-width': !isSmallView}" *ngIf="formType === 'C'">
                        <div class="sub-item-header">Unique Ingredient Identifier (UNII) Number</div>
                        <div class= "text-content-detail-body">{{data.uniiNumber}}</div>
                    </div>
                    <div [ngClass]="{'half-width': !isSmallView}" *ngIf="formType === 'D'">
                        <div class="sub-item-header">Indications for Therapeutic Claim</div>
                        <div class= "text-content-detail-body">{{data.theraClaim}}</div>
                    </div>
                    <div [ngClass]="{'half-width': !isSmallView}">
                        <div class="sub-item-header">Code Designation(s)</div>
                        <div class= "text-content-detail-body">{{data.codeDesignation}}</div>
                    </div>
                </div>
                <div [ngClass]="{'full-width': !isSmallView}" *ngIf="formType === 'E'">
                    <div [ngClass]="{'half-width': !isSmallView}">
                        <div class="sub-item-header">Polymer present</div>
                        <div class= "text-content-detail-body">{{data.isPolymerPresent}}</div>
                    </div>
                    <div [ngClass]="{'half-width': !isSmallView}">
                        <div class="sub-item-header">Semi-interpenetrating network formed</div>
                        <div class= "text-content-detail-body">{{data.semiInterNetwork}}</div>
                    </div>
                </div>
                <div [ngClass]="{'full-width': !isSmallView}" *ngIf="formType === 'E'">
                    <div [ngClass]="{'half-width': !isSmallView}">
                        <div class="sub-item-header">Degree of Polymerization</div>
                        <div class= "text-content-detail-body">{{data.degreeOfPolymerization}}</div>
                    </div>
                    <div [ngClass]="{'half-width': !isSmallView}">
                        <div class="sub-item-header">Formula for each monomer, and for the whole polymer</div>
                        <div class= "text-content-detail-body">{{data.monomerFormula}}</div>
                    </div>
                </div>
                <div [ngClass]="{'full-width': !isSmallView}" *ngIf="formType === 'E'">
                    <div [ngClass]="{'half-width': !isSmallView}">
                        <div class="sub-item-header">Chemicals Attached</div>
                        <div class= "text-content-detail-body">{{data.chemicalsAttached}}</div>
                    </div>
                    <div [ngClass]="{'half-width': !isSmallView}">
                        <div class="sub-item-header">Manufacturing Process</div>
                        <div class= "text-content-detail-body">{{data.manufacturingProcess}}</div>
                    </div>
                </div>
                <div [ngClass]="{'full-width': !isSmallView}" *ngIf="formType === 'E'">
                    <div [ngClass]="{'half-width': !isSmallView}">
                        <div class="sub-item-header">Chemical Abstracts Service (CAS) Registry Number</div>
                        <div class= "text-content-detail-body">{{data.casRegistryNumber}}</div>
                    </div>
                    <div [ngClass]="{'half-width': !isSmallView}">
                        <div class="sub-item-header">Purity of 2-Hydroxyethyl Methacrylate (if applicable)</div>
                        <div class= "text-content-detail-body">{{data.purity}}</div>
                    </div>
                </div>
                <div [ngClass]="{'full-width': !isSmallView}" *ngIf="formType === 'E'">
                    <div [ngClass]="{'half-width': !isSmallView}">
                        <div class="sub-item-header">Water Content at Ambient Temperature (23 ± 2°C)</div>
                        <div class= "text-content-detail-body">{{data.waterContentAtAmbientTemp}}</div>
                    </div>
                    <div [ngClass]="{'half-width': !isSmallView}">
                        <div class="sub-item-header">Water Content</div>
                        <ul class="list-items no-list">
                            <li><span>Before and After Modification</span> : <span class= "text-content-detail-body"> {{data.waterContent}}</span></li>
                            <li><span>Mean value ± Standard deviation</span> : <span class= "text-content-detail-body"> {{data.waterContentMeanValue}}</span></li>
                            <li><span>Number of Measurements</span> : <span class= "text-content-detail-body"> {{data.waterContentMeasurement}}</span></li>
                        </ul>
                    </div>
                </div>
                <div [ngClass]="{'full-width': !isSmallView}" *ngIf="formType === 'E'">
                    <div [ngClass]="{'half-width': !isSmallView}">
                        <div class="sub-item-header">Oxygen Permeability at 35°C</div>
                        <div class= "text-content-detail-body">{{data.oxygenPermeability35}}</div>
                    </div>
                    <div [ngClass]="{'half-width': !isSmallView}">
                        <div class="sub-item-header">Oxygen Permeability</div>
                        <ul class="list-items no-list">
                            <li><span>Before and After Modification</span> : <span class= "text-content-detail-body"> {{data.oxygenPermeability}}</span></li>
                            <li><span>Mean value ± Standard deviation</span> : <span class= "text-content-detail-body"> {{data.oxygenPermeabilityMeanValue}}</span></li>
                            <li><span>Number of Measurements</span> : <span class= "text-content-detail-body"> {{data.oxygenPermeabilityMeasurement}}</span></li>
                            <li><span>Method Used</span> : <span class= "text-content-detail-body"> {{data.oxygenPermeabilityMethod}}</span></li>
                        </ul>
                    </div>
                </div>
                <div [ngClass]="{'full-width': !isSmallView}">
                    <div [ngClass]="{'half-width': !isSmallView}">
                        <div class="sub-item-header">Trademark(s)</div>
                        <div class= "text-content-detail-body">{{data.trademark}}</div>
                    </div>
                    <div [ngClass]="{'half-width': !isSmallView}">
                        <div class="sub-item-header">Manufacturer(s)</div>
                        <div class= "text-content-detail-body">{{data.manufacturer}}</div> 
                    </div>
                </div>
                <div [ngClass]="{'full-width': !isSmallView}" *ngIf="formType != 'E'">
                    <div [ngClass]="{'half-width': !isSmallView}">
                        <div class="sub-item-header">Trivial Name(s)</div>
                        <div class= "text-content-detail-body">{{data.trivialName}}</div>
                    </div>
                    <div [ngClass]="{'half-width': !isSmallView}"  *ngIf="('A,B,C,F').includes(formType)">
                        <div class="sub-item-header">Principal Therapeutic Use(s)</div>
                        <div class= "text-content-detail-body">{{data.principalTheraUse}}</div>
                    </div>
                </div>
                <div [ngClass]="{'full-width': !isSmallView}" *ngIf="('A,B,F').includes(formType)">
                    <div [ngClass]="{'half-width': !isSmallView}">
                        <div class="sub-item-header">Pharmacologic Action</div>
                        <div class= "text-content-detail-body">{{data.pharmaAction}}</div>
                    </div>
                    <div [ngClass]="{'half-width': !isSmallView}" *ngIf="('B,F').includes(formType)">
                        <div class="sub-item-header">Code Designation(s)</div>
                        <div class= "text-content-detail-body">{{data.codeDesignation}}</div>
                    </div>
                    <div [ngClass]="{'half-width': !isSmallView}" *ngIf="formType === 'A'">
                        <div class="sub-item-header">Unique Ingredient Identifier (UNII) Number</div>
                        <div class= "text-content-detail-body">{{data.uniiNumber}}</div>
                    </div>
                </div>
                <div [ngClass]="{'full-width': !isSmallView}" *ngIf="('A,B,F').includes(formType)">
                    <div [ngClass]="{'half-width': !isSmallView}">
                        <div class="sub-item-header">Does the substance bind to a Receptor, Enzyme, or Other Target?</div>
                        <ul class="list-items no-list" *ngIf="data.bindToReceptorExplanation">
                        <li class= "text-content-detail-body">{{data.bindToReceptor}}</li>
                            <li class= "text-content-detail-body">{{data.bindToReceptorExplanation}}</li>
                        </ul>
                        <div *ngIf="!data.bindToReceptorExplanation">{{data.bindToReceptor}}</div>
                    </div>
                    <div [ngClass]="{'half-width': !isSmallView}">
                        <div class="sub-item-header">WHO / INN Submission</div>
                        <ul class="list-items no-list" *ngIf="data.innSubmission === 'Yes'">
                            <li class= "text-content-detail-body">{{data.innSubmissionNumber}}</li>
                            <li class= "text-content-detail-body">{{data.innSubmissionExplanation}}</li>
                        </ul>
                        <div class= "text-content-detail-body" *ngIf="data.innSubmission !== 'Yes'">No</div>
                    </div>
                </div>
                <div [ngClass]="{'full-width': !isSmallView}">
                    <div [ngClass]="{'half-width': !isSmallView}">
                        <div class="sub-item-header">Date Phase 1 clinical trials began</div>
                        <div class= "text-content-detail-body">{{data.clinicalTrialDate | date: 'MMMM d, y'}}</div>
                    </div>
                    <div [ngClass]="{'half-width': !isSmallView}" *ngIf="formType != 'E'">
                        <div class="sub-item-header">IND Application Number(s)</div>
                        <div class= "text-content-detail-body">{{data.indApplNumber}}</div>
                    </div>
                </div>
                <div class="width-100 sub-header padding-top-15">
                    <div class="sub-header">
                        Applicant Details
                    </div>
                    <div>
                        <span class="upload-btn-div" *ngIf="accessToEdit">
                            <button aria-label="Edit icon" [ngClass]="[!isSmallView ? 'upload-btn-cls btn-wdth':'upload-btn-cls btn-wdth-sm']" (click)="displayEditApplicantFields()" [disabled]="isFormLocked">
                                <span class="save-btn-lbl">Edit</span> 
                            </button>
                        </span>
                    </div>
                </div>
                <div class="width-100">
                    <div [ngClass]="{'full-width-left': !isSmallView}">
                        <div [ngClass]="{'half-width': !isSmallView}">
                            <div class="sub-item-header sub-details padding-top-25">Lead Applicant</div>
                            <div class= "text-content-detail-body">{{data.submittedBy}}</div>
                        </div>
                        <div [ngClass]="{'half-width': !isSmallView}">
                            <div class="sub-item-header sub-details padding-top-25">Applicant</div>
                            <div class= "text-content-detail-body">{{data.applicant}}</div>
                        </div>
                    </div>
                    <div [ngClass]="{'full-width-left': !isSmallView}">
                        <div [ngClass]="{'half-width': !isSmallView}">
                            <div class="sub-item-header sub-details padding-top-25">Address</div>
                            <div class= "text-content-detail-body">{{data.address}}</div>
                        </div>
                        <div [ngClass]="{'half-width': !isSmallView}">
                            <div class="sub-item-header sub-details padding-top-25">Telephone</div>
                            <div class= "text-content-detail-body">{{data.phone}}
                                <span class= "text-content-detail-body" *ngIf="data.phoneType ">({{data.phoneType}})</span> <!-- && data.phoneType.startsWith('')-->
                            </div>
                        </div>
                    </div>
                    <div [ngClass]="{'full-width-left': !isSmallView}">
                        <div [ngClass]="{'half-width': !isSmallView}">
                            <div class="sub-item-header sub-details padding-top-25">Primary Contact</div>
                            <div class= "text-content-detail-body">{{data.contactPerson}}</div>
                        </div>
                        <div [ngClass]="{'half-width': !isSmallView}">
                            <div class="sub-item-header sub-details padding-top-25">Pronoun</div>
                            <div class= "text-content-detail-body">{{data.pronoun}}</div>
                        </div>
                    </div>
                    <div [ngClass]="{'full-width-left': !isSmallView}">
                        <div [ngClass]="{'half-width': !isSmallView}">
                            <div class="sub-item-header sub-details padding-top-25">Title</div>
                            <div class= "text-content-detail-body">{{data.title}}</div>
                        </div>
                        <div [ngClass]="{'half-width': !isSmallView}">
                            <div class="sub-item-header sub-details padding-top-25">Email Address</div>
                            <div class= "text-content-detail-body">{{data.emailAddress}}</div>
                        </div>
                    </div>
                    <div [ngClass]="{'full-width-left': !isSmallView}">
                        <div class="sub-item-header sub-details padding-top-25">Previous Applicant</div>
                        <div class= "text-content-detail-body">{{data.previousApplicantName}}</div>
                    </div>
                </div>
                <div class="width-100">
                    <div class="suppl-docs-header width-100">
                        <span class="sub-header">
                            Supplemental Documents
                        </span>
                        <span class="upload-btn-div suppl-buttons-div" *ngIf="!isAmaAdminOrNegotiator() && !isViewOnly">
                            <button aria-label="Upload icon" class="upload-btn-cls upload-btn-wdth" (click)="uploadDocument()" [disabled]="isFormLocked">
                                <span class="save-btn-lbl">Upload</span> 
                            </button>
                        </span>
                    </div>
                    <div class="suppl-docs-btns" *ngIf="isAmaAdminOrNegotiator()">
                        <div class="suppl-buttons-spacing"></div>
                        <div class="suppl-buttons-spacing">
                            <span class="suppl-buttons-div">
                                <button aria-label="Upload icon" class="upload-btn-cls upload-btn-wdth" (click)="uploadDocument()" [disabled]="isFormLocked">
                                    <span class="save-btn-lbl">Upload</span> 
                                </button>
                            </span>
                            <span class="suppl-buttons-div">
                                <button aria-label="Download All icon" class="upload-btn-cls upload-btn-wdth" (click)="downloadAllDocuments()">
                                    <span class="save-btn-lbl">Download All</span> 
                                </button>
                            </span>
                        </div>
                    </div>
                    <div class="width-100" *ngIf="hasSupportDocs" >
                        <mat-card [ngClass]="[!isSmallView ?'suppl-docs-cls':'suppl-docs-cls-sm']" *ngFor="let item of supplDocList">
                            <mat-card-content class="suppl-docs-card-content">
                                <div class="suppl-docs-card-sub-content">
                                    <div [ngClass]="'suppl-docs-icon ' + item.type"></div>
                                    <div class="suppl-docs-item">
                                    <div class="suppl-docs-name">{{item.name}}</div>
                                    <div class="suppl-docs-type">{{item.fileType}}</div>
                                    </div>
                                    <button class="suppl-docs-dtls-cls" mat-icon-button [matMenuTriggerFor]="downloadMenu"
                                        aria-label="More details button with a menu" [matMenuTriggerData]="{'element': item}"> 
                                        <mat-icon class="details-cls">more_vert</mat-icon>
                                    </button>
                                </div>
                            </mat-card-content>
                        </mat-card>
                    </div>
                    <div *ngIf="!hasSupportDocs">
                        N/A
                    </div>
                </div>

                <mat-menu #downloadMenu="matMenu" class="menu-containr">
                    <ng-template matMenuContent let-item="element">
                    <button mat-menu-item (click)="downloadDocument(item)">
                        <mat-icon>download</mat-icon>
                        <span>Download</span>
                    </button>
                    </ng-template>
                </mat-menu>
                
                <div class="width-100">
                <div [ngClass]="[!isSmallView?'bottom-buttons-section':'padding-top-35']">
                    <div><button aria-label="Return button" class="save-btn-cls orange-background width-350" (click)="returnToSource()">
                        <span class="save-btn-lbl">Return to {{sourceName}}</span>
                    </button></div> &nbsp; &nbsp;
                    <div><button aria-label="Print Copy" class="save-btn-cls blue-background width-350" (click)="printCopy()">
                        <mat-icon class="print-btn-icon">print</mat-icon><span class="save-btn-lbl">Print Copy</span> 
                    </button></div>
                </div>
                </div>
                
            </div>
            <div *ngIf="!isSmallView" class="detail-mid-container">&nbsp;</div>
            <div *ngIf="!isSmallView" class="detail-right-container">
                <div class="width-100">
                    <div class="sub-item-header sub-details">File Number</div>
                    <div *ngIf="!isUsanAdmin" class= "text-content-detail-body">{{data.fileNumber}}</div>
                    <div *ngIf="isUsanAdmin" class="user-selection-action">
                        <mat-form-field *ngIf="!fileNumberEdit"> 
                            <input matInput [value]="[data.fileNumber? data.fileNumber: 'Enter File Number']" readonly>
                        </mat-form-field>
                        <mat-form-field *ngIf="fileNumberEdit">
                             <input matInput [(ngModel)]="selectedFileNumber" [disabled]="isFormLocked">
                        </mat-form-field>
                        <span class="padding-left-10 user-selection-action">
                            <button class="bgcolor-white user-name-edit" aria-label="Edit" *ngIf="!fileNumberEdit" (click)="enableCaseEdit('fileNumber')" [disabled]="isFormLocked">
                                <mat-icon>{{ isFormLocked ? 'lock' : 'edit' }}</mat-icon>
                            </button>
                            <button class="bgcolor-white user-name-edit" aria-label="Save" *ngIf="fileNumberEdit" (click)="updateCase('fileNumber')" [disabled]="disableEditFileNumber('fileNumber')">
                                <mat-icon>check</mat-icon>
                            </button>
                            <button class="bgcolor-white user-name-edit" aria-label="Cancel" *ngIf="fileNumberEdit" (click)="cancelCaseFieldSelection('fileNumber')">
                                <mat-icon>cancel</mat-icon>
                            </button>
                        </span>
                    </div>
                </div>
                <div *ngIf="formType === 'A'"  class="width-100">
                    <div class="sub-item-header sub-details">File Number Modified</div>
                    <div *ngIf="!isUsanAdmin" class= "text-content-detail-body">{{data.fileNumberModified}}</div>
                    <div *ngIf="isUsanAdmin" class="user-selection-action">
                        <mat-form-field *ngIf="!fileNumberEditMod"> 
                            <input matInput [value]="[data.fileNumberModified? data.fileNumberModified: 'Enter File Number Mod']" readonly>
                        </mat-form-field>
                        <mat-form-field *ngIf="fileNumberEditMod">
                             <input matInput [(ngModel)]="selectedFileNumberMod" value="data.fileNumberModified" [disabled]="isFormLocked">
                        </mat-form-field>
                        <span class="padding-left-10 user-selection-action">
                            <button class="bgcolor-white user-name-edit" aria-label="Edit" *ngIf="!fileNumberEditMod" (click)="enableCaseEdit('fileNumberMod')" [disabled]="isFormLocked">
                                <mat-icon>{{ isFormLocked ? 'lock' : 'edit' }}</mat-icon>
                            </button>
                            <button class="bgcolor-white user-name-edit" aria-label="Save" *ngIf="fileNumberEditMod" (click)="updateCase('fileNumberMod')" [disabled]="disableEditFileNumber('fileNumberMod')">
                                <mat-icon>check</mat-icon>
                            </button>
                            <button class="bgcolor-white user-name-edit" aria-label="Cancel" *ngIf="fileNumberEditMod" (click)="cancelCaseFieldSelection('fileNumberMod')">
                                <mat-icon>cancel</mat-icon>
                            </button>
                        </span>
                    </div>
                </div>
                <div class="full-width">
                    <div class="sub-item-header sub-details">Case Number</div>
                    <div class= "text-content-detail-body">{{caseNumber}}</div>
                </div>
                <div class="full-width">
                    <div class="sub-item-header sub-details">Case Status</div>
                    <div *ngIf="!isUsanAdmin || !updateStatusListMap[data.caseStatus]" class= "text-content-detail-body">{{data.caseStatus}}</div>
                    <div *ngIf="isUsanAdmin && updateStatusListMap[data.caseStatus]" class="user-selection-action">
                        <mat-form-field *ngIf="!allowCaseStatusUpdate || isFormLocked"> 
                            <input matInput [value]="[data.caseStatus]" readonly>
                        </mat-form-field>
                        <mat-form-field *ngIf="allowCaseStatusUpdate && !isFormLocked">
                            <mat-label>Select Status</mat-label>
                            <mat-select [(value)]="selectedCaseStatus" class="user-name-input">
                                <ng-container  *ngFor="let status of updateStatusListMap[data.caseStatus]">
                                <mat-option [value]="status" >{{ status }}</mat-option>
                                </ng-container>
                            </mat-select>
                        </mat-form-field>
                        <span class="padding-left-10 user-selection-action">
                            <button class="bgcolor-white user-name-edit" aria-label="Edit Status" *ngIf="!allowCaseStatusUpdate && updateStatusListMap[data.caseStatus]" (click)="openStatusSelection()" [disabled]="isFormLocked">
                                <mat-icon>{{ isFormLocked ? 'lock' : 'edit' }}</mat-icon>
                            </button>
                            <button class="bgcolor-white user-name-edit" aria-label="Save Status" *ngIf="allowCaseStatusUpdate" (click)="updateCaseStatus()">
                                <mat-icon>check</mat-icon>
                            </button>
                            <button class="bgcolor-white user-name-edit" aria-label="Cancel" *ngIf="allowCaseStatusUpdate" (click)="cancelStatusSelection()">
                                <mat-icon>cancel</mat-icon>
                            </button>
                        </span>
                    </div>
                </div>
                <div class="width-100" *ngIf="data.caseStatus ==='Approved' || data.caseStatus ==='Closed'"> 
                    <div class="sub-item-header sub-details">Final Adopted Name</div>
                    <div class= "text-content-detail-body" *ngIf="data.caseStatus ==='Closed' || !isUsanAdmin">
                        {{data.finalAdoptedName}}
                    </div>
                    <div class="user-selection-action" *ngIf="data.caseStatus ==='Approved' && isUsanAdmin">
                        <mat-form-field *ngIf="!finalAdoptedNameEdit"> 
                            <input matInput [value]="[data.finalAdoptedName]" readonly>
                        </mat-form-field>
                        <mat-form-field *ngIf="finalAdoptedNameEdit">
                             <input matInput [(ngModel)]="selectedFinalAdoptedName" [disabled]="isFormLocked">
                        </mat-form-field>
                        <span class="padding-left-10 user-selection-action">
                            <button class="bgcolor-white user-name-edit" aria-label="Edit" *ngIf="!finalAdoptedNameEdit" (click)="enableCaseEdit('finalAdoptedName')" [disabled]="isFormLocked">
                                <mat-icon>{{ isFormLocked ? 'lock' : 'edit' }}</mat-icon>
                            </button>
                            <button class="bgcolor-white user-name-edit" aria-label="Save" *ngIf="finalAdoptedNameEdit" (click)="updateCase('finalAdoptedName')" [disabled]="disableFinalAdoptedNameEdit()">
                                <mat-icon>check</mat-icon>
                            </button>
                            <button class="bgcolor-white user-name-edit" aria-label="Cancel" *ngIf="finalAdoptedNameEdit" (click)="cancelCaseFieldSelection('finalAdoptedName')">
                                <mat-icon>cancel</mat-icon>
                            </button>
                        </span>
                    </div>
                </div>
                <div class="width-100" *ngIf="formType === 'A' && (data.caseStatus ==='Approved' || data.caseStatus ==='Closed')"> 
                    <div class="sub-item-header sub-details">Final Adopted Name - Modified</div>
                    <div class= "text-content-detail-body" *ngIf="data.caseStatus ==='Closed' || !isUsanAdmin">
                        {{data.finalAdoptedNameMod}}
                    </div>
                    <div class="user-selection-action" *ngIf="data.caseStatus ==='Approved' && isUsanAdmin">
                        <mat-form-field *ngIf="!finalAdoptedNameModEdit"> 
                            <input matInput [value]="[data.finalAdoptedNameMod]" readonly>
                        </mat-form-field>
                        <mat-form-field *ngIf="finalAdoptedNameModEdit">
                             <input matInput [(ngModel)]="selectedFinalAdoptedNameMod" [disabled]="isFormLocked">
                        </mat-form-field>
                        <span class="padding-left-10 user-selection-action">
                            <button class="bgcolor-white user-name-edit" aria-label="Edit" *ngIf="!finalAdoptedNameModEdit" (click)="enableCaseEdit('finalAdoptedNameMod')" [disabled]="isFormLocked">
                                <mat-icon>{{ isFormLocked ? 'lock' : 'edit' }}</mat-icon>
                            </button>
                            <button class="bgcolor-white user-name-edit" aria-label="Save" *ngIf="finalAdoptedNameModEdit" (click)="updateCase('finalAdoptedNameMod')" [disabled]="disableFinalAdoptedNameModEdit()">
                                <mat-icon>check</mat-icon>
                            </button>
                            <button class="bgcolor-white user-name-edit" aria-label="Cancel" *ngIf="finalAdoptedNameModEdit" (click)="cancelCaseFieldSelection('finalAdoptedNameMod')">
                                <mat-icon>cancel</mat-icon>
                            </button>
                        </span>
                    </div>
                </div>
                <div class="width-100" *ngIf="data.caseStatus ==='Approved' || data.caseStatus ==='Closed'">
                    <div class="sub-item-header sub-details">Date Name Adopted or Closed</div>
                    <div *ngIf="!isUsanAdmin" class= "text-content-detail-body">{{this.data.adoptedOrClosedDate | date: 'MMMM d, y'}}</div>
                    <div *ngIf="isUsanAdmin" class="user-selection-action">
                        <mat-form-field>
                            <input matInput [matDatepicker]="picker" (dateChange)="selectAdoptedOrClosedDate($event.value)" [value]="adoptedOrClosedDate" [disabled]="isFormLocked">
                            <mat-datepicker-toggle  matIconSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>
                        </mat-form-field>
                        <span class="padding-left-10 user-selection-action">
                            <button class="bgcolor-white user-name-edit" aria-label="Save" (click)="updateCase('adoptedOrClosedDate')" [disabled]="disableAdoptedOrClosedDate()">
                                <mat-icon>{{ isFormLocked ? 'lock' : 'check' }}</mat-icon>
                            </button>
                        </span>
                    </div>
                </div>
                <div class="width-100">
                    <div class="sub-item-header sub-details">Payment Status</div>
                    <div class= "text-content-detail-body">{{paymentStatus}}</div>
                    <div class= "payment-container" *ngIf="paymentStatus !== 'Completed' && !isViewOnly">
                        <button aria-label="Save comments icon" class="save-btn-cls width-100 blue-background" (click)="openPaymentModal()" [disabled]="isFormLocked">
                            <mat-icon>save</mat-icon><span class="save-btn-lbl">Add Payment</span> 
                        </button>
                    </div>
                </div>
                <div class="width-100" *ngIf="paymentStatus === 'Completed'">
                    <div class="sub-item-header sub-details">Payment Type</div>
                    <div class= "text-content-detail-body">{{data.paymentType}}</div>
                </div>
                <div class="width-100" *ngIf="data.paymentType ==='ACH'">
                    <div class="sub-item-header sub-details">ACH Transaction ID</div>
                    <div class= "text-content-detail-body wrap-break">{{data.paymentDetails}}</div>
                </div>
                <div class="width-100" *ngIf="data.paymentType ==='WIRE' && isUsanAdmin"> 
                    <div class="sub-item-header sub-details">CR#</div>
                    <div class="user-selection-action">
                        <mat-form-field *ngIf="!cashReceiptNumberEdit"> 
                            <input matInput [value]="[data.cashReceiptNumber? data.cashReceiptNumber: 'Enter Cash Receipt #']" readonly>
                        </mat-form-field>
                        <mat-form-field *ngIf="cashReceiptNumberEdit">
                             <input matInput [(ngModel)]="selectedCashReceiptNumber" [disabled]="isFormLocked">
                        </mat-form-field>
                        <span class="padding-left-10 user-selection-action">
                            <button class="bgcolor-white user-name-edit" aria-label="Edit" *ngIf="!cashReceiptNumberEdit" (click)="enableCaseEdit('cashReceiptNumber')" [disabled]="isFormLocked">
                                <mat-icon>{{ isFormLocked ? 'lock' : 'edit' }}</mat-icon>
                            </button>
                            <button class="bgcolor-white user-name-edit" aria-label="Save" *ngIf="cashReceiptNumberEdit" (click)="updateCase('cashReceiptNumber')" [disabled]="disableCashReceiptNumberEdit()">
                                <mat-icon>check</mat-icon>
                            </button>
                            <button class="bgcolor-white user-name-edit" aria-label="Cancel" *ngIf="cashReceiptNumberEdit" (click)="cancelCaseFieldSelection('cashReceiptNumber')">
                                <mat-icon>cancel</mat-icon>
                            </button>
                        </span>
                    </div>
                </div>
                <div class="width-100">
                    <div class="sub-item-header sub-details">Payment Date</div>
                    <div *ngIf="!isUsanAdmin" class= "text-content-detail-body">{{this.data.paymentReceivedDate | date: 'MMMM d, y'}}</div>
                    <div *ngIf="isUsanAdmin" class="user-selection-action">
                        <mat-form-field>
                            <input matInput [matDatepicker]="picker" (dateChange)="selectPaymentDate($event.value)" [value]="paymentReceivedDate" [disabled]="isFormLocked"> <!--   [value]="data.paymentReceivedDate" -->
                            <mat-datepicker-toggle  matIconSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>
                        </mat-form-field>
                        <span class="padding-left-10 user-selection-action">
                            <button class="bgcolor-white user-name-edit" aria-label="Save" (click)="updateCase('paymentDate')" [disabled]="disablePaymentDateEdit()" [disabled]="isFormLocked">
                                <mat-icon>{{ isFormLocked ? 'lock' : 'check' }}</mat-icon>
                            </button>
                        </span>
                    </div>
                </div>
                <div class="full-width">
                    <div class="sub-item-header sub-details">Negotiator</div>
                    <div *ngIf="!isUsanAdmin" class= "text-content-detail-body">{{data.negotiator}}</div>
                    <div *ngIf="isUsanAdmin" class="user-selection-action">
                        <mat-form-field> 
                            <input matInput [value]="[data.negotiator? data.negotiator: 'Assign Negotiator']" readonly>
                        </mat-form-field>
                        <span class="padding-left-10 user-selection-action">
                            <button class="bgcolor-white user-name-edit" aria-label="Edit Negotiator" *ngIf="!showNegotiators" (click)="openNegotiatorSelection()" [disabled]="isFormLocked">
                                <mat-icon>{{ isFormLocked ? 'lock' : 'edit' }}</mat-icon>
                            </button>
                        </span>
                    </div>
                </div>
                <div class="full-width">
                    <div class="sub-item-header sub-details padding-bottom-0">USAN User</div>
                    <div *ngIf="!isOrgAdmin" class= "text-content-detail-body">{{data.usanUserName}}</div>
                    <div *ngIf="isOrgAdmin" class="user-selection-action">
                        <mat-form-field *ngIf="!showUsers"> 
                            <input matInput [value]="[data.usanUserName? data.usanUserName: 'Assign User']"  readonly> 
                        </mat-form-field>
                        <mat-form-field  *ngIf="showUsers && usersLoadingComplete" [disabled]="isFormLocked">
                            <mat-label>Select User</mat-label>
                            <mat-select [(value)]="selectedUser" class="user-name-input">
                                <ng-container  *ngFor="let user of usersList">
                                <mat-option [value]="user" >{{ user.userName }}</mat-option>
                                </ng-container>
                            </mat-select>
                        </mat-form-field>
                        <span class="padding-left-10 user-selection-action">
                            <button class="bgcolor-white user-name-edit" aria-label="Edit User" *ngIf="!showUsers" (click)="openUserSelection('user')" [disabled]="isFormLocked">
                                <mat-icon>{{ isFormLocked ? 'lock' : 'edit' }}</mat-icon>
                            </button>
                            <button class="bgcolor-white user-name-edit" aria-label="Save User" *ngIf="showUsers" (click)="addUserToApplication('user')" [disabled]="disableUpdateButton()">
                                <mat-icon>check</mat-icon>
                            </button>
                            <button class="bgcolor-white user-name-edit" aria-label="Cancel" *ngIf="showUsers" (click)="cancelUserSelection('user')">
                                <mat-icon>cancel</mat-icon>
                            </button>
                        </span>
                    </div>
                </div>
                <div class="full-width">
                    <div class="sub-item-header sub-details padding-bottom-0">Application Collaborator 1</div>
                    <div *ngIf="!isOrgAdmin" class= "text-content-detail-body">{{data.collaborator1}}</div>
                    <div *ngIf="isOrgAdmin">
                        <mat-form-field *ngIf="!showCollab1 || isFormLocked"> 
                            <input matInput [value]="[data.collaborator1? data.collaborator1: 'Assign Collaborator']" readonly>
                        </mat-form-field>
                        <mat-form-field *ngIf="showCollab1 && usersLoadingComplete && !isFormLocked">
                            <mat-select [(value)]="selectedCollaborator1" class="user-name-input">
                                <ng-container  *ngFor="let user of applicantsList">
                                <mat-option [value]="user" >{{ user.userName }}</mat-option>
                                </ng-container>
                            </mat-select>
                        </mat-form-field>
                        <span class="padding-left-10">
                            <button class="bgcolor-white user-name-edit" aria-label="Edit User" *ngIf="!showCollab1" (click)="openUserSelection('collab1')"> 
                                <mat-icon>{{ isFormLocked ? 'lock' : 'edit' }}</mat-icon>
                            </button>
                            <button class="bgcolor-white user-name-edit" aria-label="Save User" *ngIf="showCollab1" (click)="addUserToApplication('collab1')" [disabled]="disableUpdateCollabButton('collab1')">
                                <mat-icon>check</mat-icon>
                            </button>
                            <button class="bgcolor-white user-name-edit" aria-label="Cancel" *ngIf="showCollab1" (click)="cancelUserSelection('collab1')">
                                <mat-icon>cancel</mat-icon>
                            </button>
                        </span>
                    </div>
                </div>
                <div class="full-width">
                    <div class="sub-item-header sub-details padding-bottom-0">Application Collaborator 2</div>
                    <div *ngIf="!isOrgAdmin" class= "text-content-detail-body">{{data.collaborator2}}</div>
                    <div *ngIf="isOrgAdmin">
                        <mat-form-field *ngIf="!showCollab2 || isFormLocked"> 
                            <input matInput [value]="[data.collaborator2? data.collaborator2: 'Assign Collaborator']" readonly>
                        </mat-form-field>
                        <mat-form-field *ngIf="showCollab2 && usersLoadingComplete && !isFormLocked">
                            <mat-select [(value)]="selectedCollaborator2" class="user-name-input">
                                <ng-container  *ngFor="let user of applicantsList">
                                <mat-option [value]="user" >{{ user.userName }}</mat-option>
                                </ng-container>
                            </mat-select>
                        </mat-form-field>
                        <span class="padding-left-10">
                            <button class="bgcolor-white user-name-edit" aria-label="Edit User" *ngIf="!showCollab2" (click)="openUserSelection('collab2')"> 
                                <mat-icon>{{ isFormLocked ? 'lock' : 'edit' }}</mat-icon>
                            </button>
                            <button class="bgcolor-white user-name-edit" aria-label="Save User" *ngIf="showCollab2" (click)="addUserToApplication('collab2')" [disabled]="disableUpdateCollabButton('collab2')">
                                <mat-icon>check</mat-icon>
                            </button>
                            <button class="bgcolor-white user-name-edit" aria-label="Cancel" *ngIf="showCollab2" (click)="cancelUserSelection('collab2')">
                                <mat-icon>cancel</mat-icon>
                            </button>
                        </span>
                    </div>
                </div>
                <div class="full-width">
                    <div class="sub-item-header sub-details">Submitted Date</div>
                    <div class= "text-content-detail-body">{{data.submittedDate | date: 'MMMM d, y'}}</div>
                </div>
                <div class="full-width">
                    <div class="sub-item-header sub-details">Latest Comment</div> 
                    <div class= "text-content-detail-body">{{latestComment}}</div> 
                    <div *ngIf="hasComments" class="prior-cls">
                        <a (click)="displayPriorComments()">Prior Comments</a>
                    </div>
                </div>
                <div class="full-width" *ngIf="!isViewOnly">
                    <div >
                        <mat-form-field class="comments-text-cls">
                            <textarea matInput  placeholder="Add New Comments" [(ngModel)]="newComments" maxlength="255" [disabled]="isFormLocked"></textarea>
                        </mat-form-field>
                    </div>
                    <div>
                        <button aria-label="Save comments icon" class="save-btn-cls width-100 blue-background" (click)="saveComments()" [disabled]="isFormLocked">
                            <mat-icon>save</mat-icon><span class="save-btn-lbl">Save Comments</span> 
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="loadingComplete && !showResults">No details found </div>

        <ng-template #priorComments>
            <div class="comments-dialog-container">
                <span mat-dialog-title class="header-text"><h2>Prior Comments</h2></span>  
                <div mat-dialog-content >
                    <div class="width-100">
                            <div class="resultsDiv">
                                <ul class="comments-list">
                                    <li *ngFor="let item of commentsList" class="comments-list-item" >
                                        <span class= "text-content-detail-body">{{item.value}} - {{item.date | date: 'MMMM d, y'}} </span>
                                    </li>
                                </ul>
                            </div>
                            <div class="cancel-btn-div">
                                <button aria-label="Cancel" class="save-btn-cls blue-background" (click)="cancel()">
                                    <span class="save-btn-lbl">Cancel</span> 
                                </button>
                            </div>
                    </div>
                </div>
            </div>
        </ng-template>

        <ng-template #addNegotiator>
            <div class="comments-dialog-container">
                <span mat-dialog-title class="header-text"><h2>Assign Negotiator</h2></span>  
                <div mat-dialog-content >
                    <div class="user-dialog-sub-container">
                        <div class="user-selection-action" *ngIf="!isSmallView"> 
                            <span class="name-field-spn">
                                <mat-label>First Name</mat-label>
                                <mat-form-field>
                                    <input matInput [(ngModel)]="negotiatorFirstName"> 
                                </mat-form-field>
                            </span>
                            <span class="name-field-spn">
                                <mat-label>Last Name</mat-label>
                                <mat-form-field>
                                    <input matInput [(ngModel)]="negotiatorLastName" minlength="2"> 
                                </mat-form-field> 
                            </span>
                            <span class="user-selection-action"> <!-- padding-left-10 padding-top-25-->
                                <button class="bgcolor-white search-nego-icon" aria-label="Search for Negotiator" (click)="searchForNegotiator()" [disabled]="disableSearchBtn()"> 
                                    <mat-icon>search</mat-icon>
                                </button>
                                <button class="bgcolor-white search-nego-icon" aria-label="Cancel" *ngIf="searchNegotiatorComplete && noNegotiatorsFound" (click)="resetNegotiatorSelection()">
                                    <mat-icon>cancel</mat-icon> 
                                </button>
                            </span>
                        </div>    
                        <div *ngIf="isSmallView" class="width-100">
                            <div>
                                <mat-label>First Name</mat-label>
                                <mat-form-field>
                                    <input matInput [(ngModel)]="negotiatorFirstName"> 
                                </mat-form-field>
                            </div>
                            <div>
                                <mat-label>Last Name</mat-label>
                                <mat-form-field>
                                    <input matInput [(ngModel)]="negotiatorLastName"> 
                                </mat-form-field>
                            </div>
                            <div class="save-btn-div width-100" >
                                <button aria-label="Search" class="save-btn-cls blue-background width-100" [disabled]="disableSearchBtn()"
                                    (click)="searchForNegotiator()">
                                    <span class="save-btn-lbl">Search</span> 
                                </button>
                            </div>
                        </div>
                        <div class="user-selection-action" *ngIf="showNegotiatorResults && searchNegotiatorComplete">
                            <mat-form-field [ngClass]="[isSmallView ? 'width-100' : 'sel-nego-name-field']"> 
                                <mat-label>Select Negotiator</mat-label>
                                <mat-select  (selectionChange)="selectingNegotiator($event.value)" [value]="selectedNegotiator"> 
                                    <mat-option [value]="item" *ngFor="let item of negotiatorDataList">{{ item.name }} ({{item.email}}) </mat-option>
                                </mat-select>
                            </mat-form-field>  
                            <span class="padding-left-10">
                                <button class="bgcolor-white search-nego-icon" aria-label="Cancel" (click)="resetNegotiatorSelection()">
                                    <mat-icon>cancel</mat-icon>
                                </button>
                            </span>
                        </div>                               
                        <div *ngIf="loadingNegotiators" class="spinner-div">
                            <mat-spinner class="spinner-cls"></mat-spinner>
                        </div>
                        <div *ngIf="searchNegotiatorComplete && noNegotiatorsFound">
                            <span class="user-dialog-sub-header">Sorry, no results found.</span>
                        </div>
                        <div *ngIf="searchNegotiatorComplete && sameNegotiatorExistsAlready">
                            <span class="user-dialog-sub-header red-clr">This negotiator is already assigned to this case.</span>
                        </div>
                        <div class="save-btn-div width-100" *ngIf="negotiatorSelectionComplete && !sameNegotiatorExistsAlready"> 
                            <button aria-label="Assign" class="save-btn-cls blue-background width-100" (click)="assignNegotiator()">
                                <span class="save-btn-lbl">Assign</span> 
                            </button>
                        </div>
                        <div class="save-btn-div width-100" >
                            <button aria-label="Cancel" class="save-btn-cls orange-background width-100" (click)="cancelNegotiatorSearch()">
                                <span class="save-btn-lbl">Cancel</span> 
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>

        <ng-template #editSubstanceFields>
            <div class="comments-dialog-container">
                <span mat-dialog-title class="sub-header"><h4>Edit Application for {{formName}} - Form {{formType}}</h4></span>  
                <div mat-dialog-content>
                    <div class="user-dialog-sub-container">
                        <form [formGroup]="editFieldsForm">
                        <div class="edit-fields-div"> 
                            <div *ngIf="('A,B,C,E,F').includes(formType)">
                                <mat-label *ngIf="('A,B,E,F').includes(formType)">Suggested name(s) in order of preference <span class="red-clr"> *</span></mat-label> 
                                <mat-label *ngIf="formType === 'C'">Suggested name<span class="red-clr"> *</span></mat-label> 
                                <mat-form-field>
                                    <input matInput formControlName="firstSuggestedName"> 
                                    <mat-error *ngIf="this.editFieldsForm.get('firstSuggestedName')?.errors && this.editFieldsForm.get('firstSuggestedName')?.hasError('invalidNumberOfSuggestedNames')">
                                        <span>Invalid number of Suggested Name(s)</span>
                                    </mat-error>
                                    <mat-error *ngIf="this.editFieldsForm.get('firstSuggestedName')?.errors && this.editFieldsForm.get('firstSuggestedName')?.hasError('invalidSuggestedNames')">
                                        <span>Invalid Suggested Name(s)</span>
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div *ngIf="formType === 'D'">
                                <mat-label>Name for which you are requesting a Revision </mat-label>
                                <mat-form-field>
                                    <input matInput formControlName="revisionName"> 
                                    <mat-error *ngIf="this.editFieldsForm.get('revisionName')?.errors && this.editFieldsForm.get('revisionName')?.hasError('invalidNumberOfSuggestedNames')">
                                        <span>Invalid number of Revision name</span>
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div *ngIf="formType ==='A'">
                                <mat-label>Designation for Salt Form <span class="red-clr"> *</span></mat-label>
                                <mat-form-field>
                                    <input matInput formControlName="designationForSalt"> 
                                </mat-form-field>
                            </div>
                            <div *ngIf="formType ==='D'">
                                <mat-label>Reason for Revision</mat-label>
                                <mat-form-field>
                                    <input matInput formControlName="revisionReason"> 
                                </mat-form-field>
                            </div>
                            <div *ngIf="('B,C,D,E').includes(formType)">
                                <mat-label>Chemical Name(s) or Description <span class="red-clr"> *</span></mat-label>
                                <mat-form-field>
                                    <input matInput formControlName="chemName"> 
                                </mat-form-field>
                            </div> 
                            <div *ngIf="formType ==='F'">
                                <mat-label>Systematic Name(s) or Description <span class="red-clr"> *</span></mat-label>
                                <mat-form-field>
                                    <input matInput formControlName="systematicName"> 
                                </mat-form-field>
                            </div>
                            <div *ngIf="formType ==='A'">
                                <mat-label>Chemical Name(s) or Description for Single Entity <span class="red-clr"> *</span></mat-label>
                                <mat-form-field>
                                    <input matInput formControlName="chemNameForEntity"> 
                                </mat-form-field>
                            </div>
                            <div *ngIf="formType ==='A'">
                                <mat-label>Chemical Name(s) or Description for Salt Form <span class="red-clr"> *</span></mat-label>
                                <mat-form-field>
                                    <input matInput formControlName="chemNameForSalt"> 
                                </mat-form-field>
                            </div>
                            <div *ngIf="formType ==='A'">
                                <mat-label>Molecular Formula for Single Entity <span class="red-clr"> *</span></mat-label>
                                <mat-form-field>
                                    <input matInput formControlName="molecularFormulaForEntity"> 
                                    <mat-error *ngIf="this.editFieldsForm.get('molecularFormulaForEntity')?.invalid && this.editFieldsForm.get('molecularFormulaForEntity')?.touched">
                                        <span>Invalid formula</span>
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div *ngIf="formType ==='A'">
                                <mat-label>Molecular Formula for Salt Form <span class="red-clr"> *</span></mat-label>
                                <mat-form-field>
                                    <input matInput formControlName="molecularFormulaForSalt">
                                    <mat-error *ngIf="this.editFieldsForm.get('molecularFormulaForSalt')?.invalid && this.editFieldsForm.get('molecularFormulaForSalt')?.touched">
                                        <span>Invalid formula</span>
                                    </mat-error> 
                                </mat-form-field>
                            </div>
                            <div *ngIf="('B,C,D,F').includes(formType)">
                                <mat-label>Molecular Formula <span class="red-clr"> *</span></mat-label>
                                <mat-form-field>
                                    <input matInput formControlName="molecularFormula"> 
                                    <mat-error *ngIf="this.editFieldsForm.get('molecularFormula')?.invalid && this.editFieldsForm.get('molecularFormula')?.touched">
                                        <span>Invalid formula</span>
                                    </mat-error>
                                </mat-form-field>
                            </div> 
                            <div *ngIf="formType ==='A'">
                                <mat-label>Molecular Weight for Single Entity <span class="red-clr"> *</span></mat-label>
                                <mat-form-field>
                                    <input matInput formControlName="molecularWeightForEntity">
                                    <mat-error *ngIf="this.editFieldsForm.get('molecularWeightForEntity')?.invalid && this.editFieldsForm.get('molecularWeightForEntity')?.touched">
                                        <span>Invalid</span>
                                    </mat-error> 
                                </mat-form-field>
                            </div>
                            <div *ngIf="formType ==='A'">
                                <mat-label>Molecular Weight for Salt Form <span class="red-clr"> *</span></mat-label>
                                <mat-form-field>
                                    <input matInput formControlName="molecularWeightForSalt"> 
                                    <mat-error *ngIf="this.editFieldsForm.get('molecularWeightForSalt')?.invalid && this.editFieldsForm.get('molecularWeightForSalt')?.touched">
                                        <span>Invalid</span>
                                    </mat-error> 
                                </mat-form-field>
                            </div>
                            <div *ngIf="('B,C,D,F').includes(formType)">
                                <mat-label>Molecular Weight <span class="red-clr"> *</span></mat-label>
                                <mat-form-field>
                                    <input matInput formControlName="molecularWeight"> 
                                    <mat-error *ngIf="this.editFieldsForm.get('molecularWeight')?.invalid && this.editFieldsForm.get('molecularWeight')?.touched">
                                        <span>Invalid</span>
                                    </mat-error> 
                                </mat-form-field>
                            </div>
                            <div *ngIf="('A,B').includes(formType)">
                                <label>Is this a Pro Drug? </label>
                                 <div class="width-100">
                                    <span *ngFor="let item of yesNoList" class="qrtr-width padding-bottom-20">
                                        <input type="radio" [value]="item" id="{{'prodDrug-'+item}}"
                                            name="isProdDrug" formControlName="isProdDrug"> 
                                        <label for="{{'prodDrug-'+item}}">{{item}}</label>
                                    </span>
                                </div>
                            </div>
                            <div *ngIf="formType ==='A'" class="full-width-left">
                                <mat-label>Chemical Abstracts Service (CAS) Registry Number for Single Entity <span class="red-clr"> *</span></mat-label>
                                <mat-form-field>
                                    <input matInput formControlName="casRegistryForEntity"> 
                                    <mat-error *ngIf="this.editFieldsForm.get('casRegistryForEntity')?.invalid && this.editFieldsForm.get('casRegistryForEntity')?.touched">
                                        <span>Invalid</span>
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div *ngIf="formType ==='A'" class="full-width-left">
                                <mat-label>Chemical Abstracts Service (CAS) Registry Number for Salt Form <span class="red-clr"> *</span></mat-label>
                                <mat-form-field>
                                    <input matInput formControlName="casRegistryForSalt">
                                    <mat-error *ngIf="this.editFieldsForm.get('casRegistryForSalt')?.invalid && this.editFieldsForm.get('casRegistryForSalt')?.touched">
                                        <span>Invalid</span>
                                    </mat-error> 
                                </mat-form-field>
                            </div>
                            <div *ngIf="('B,C,D,E,F').includes(formType)" class="full-width-left">
                                <mat-label>Chemical Abstracts Service (CAS) Registry Number <span class="red-clr"> *</span></mat-label>
                                <mat-form-field>
                                    <input matInput formControlName="casRegistryNumber"> 
                                    <mat-error *ngIf="this.editFieldsForm.get('casRegistryNumber')?.invalid && this.editFieldsForm.get('casRegistryNumber')?.touched">
                                        <span>Invalid</span>
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div *ngIf="formType ==='D'">
                                <mat-label>Indications for Therapeutic Claim </mat-label>
                                <mat-form-field>
                                    <input matInput formControlName="theraClaim"> 
                                </mat-form-field>
                            </div>
                            <div *ngIf="('A,B,C,F').includes(formType)" class="full-width-left">
                                <mat-label>Unique Ingredient Identifier (UNII) Number</mat-label>
                                <mat-form-field>
                                    <input matInput formControlName="uniiNumber"> 
                                    <mat-error *ngIf="this.editFieldsForm.get('uniiNumber')?.invalid && this.editFieldsForm.get('uniiNumber')?.touched">
                                        <span>Invalid</span>
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div *ngIf="formType ==='A'" class="full-width-left">
                                <mat-label>Code Designation(s) for Single Entity <span class="red-clr"> *</span></mat-label>
                                <mat-form-field>
                                    <input matInput formControlName="codeDesignationForEntity"> 
                                </mat-form-field>
                            </div>
                            <div *ngIf="formType ==='A'" class="full-width-left">
                                <mat-label>Code Designation(s) for Salt Form <span class="red-clr"> *</span></mat-label>
                                <mat-form-field>
                                    <input matInput formControlName="codeDesignationForSalt"> 
                                </mat-form-field>
                            </div>
                            <div *ngIf="('B,C,D,F').includes(formType)" class="full-width-left">
                                <mat-label>Code Designation(s) <span class="red-clr"> *</span></mat-label>
                                <mat-form-field>
                                    <input matInput formControlName="codeDesignation"> 
                                </mat-form-field>
                            </div>
                            <div *ngIf="formType ==='E'">
                                <mat-label>Polymer present</mat-label>
                                <mat-form-field>
                                    <input matInput formControlName="isPolymerPresent"> 
                                </mat-form-field>
                            </div>
                            <div *ngIf="formType ==='E'">
                                <mat-label>Semi-interpenetrating network formed</mat-label>
                                <mat-form-field>
                                    <input matInput formControlName="semiInterNetwork"> 
                                </mat-form-field>
                            </div>
                            <div *ngIf="formType ==='E'">
                                <mat-label>Degree of Polymerization</mat-label>
                                <mat-form-field>
                                    <input matInput formControlName="degreeOfPolymerization"> 
                                </mat-form-field>
                            </div>
                            <div *ngIf="formType ==='E'">
                                <mat-label>Formula for each monomer, and for the whole polymer</mat-label>
                                <mat-form-field>
                                    <input matInput formControlName="monomerFormula"> 
                                </mat-form-field>
                            </div>
                            <div *ngIf="formType ==='E'">
                                <mat-label>Chemicals Attached</mat-label>
                                <mat-form-field>
                                    <input matInput formControlName="chemicalsAttached"> 
                                </mat-form-field>
                            </div>
                            <div *ngIf="formType ==='E'">
                                <mat-label>Manufacturing Process</mat-label>
                                <mat-form-field>
                                    <input matInput formControlName="manufacturingProcess"> 
                                </mat-form-field>
                            </div>
                            <div *ngIf="formType ==='E'">
                                <mat-label>Purity of 2-Hydroxyethyl Methacrylate (if applicable)</mat-label>
                                <mat-form-field>
                                    <input matInput formControlName="purity"> 
                                </mat-form-field>
                            </div>
                            <div *ngIf="formType ==='E'">
                                <mat-label>Water Content at Ambient Temperature (23 ± 2°C)</mat-label>
                                <mat-form-field>
                                    <input matInput formControlName="waterContentAtAmbientTemp"> 
                                </mat-form-field>
                            </div>
                            <div *ngIf="formType ==='E'">
                                <mat-label>Water Content Before and After Modification</mat-label>
                                <mat-form-field>
                                    <input matInput formControlName="waterContent"> 
                                </mat-form-field>
                            </div>
                            <div *ngIf="formType ==='E'">
                                <mat-label>Mean value ± Standard deviation</mat-label>
                                <mat-form-field>
                                    <input matInput formControlName="waterContentMeanValue"> 
                                    <mat-error *ngIf="this.editFieldsForm.get('waterContentMeanValue')?.invalid && this.editFieldsForm.get('waterContentMeanValue')?.touched">
                                        <span>Invalid</span>
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div *ngIf="formType ==='E'">
                                <mat-label>Number of Measurements</mat-label>
                                <mat-form-field>
                                    <input matInput formControlName="waterContentMeasurement"> 
                                    <mat-error *ngIf="this.editFieldsForm.get('waterContentMeasurement')?.invalid && this.editFieldsForm.get('waterContentMeasurement')?.touched">
                                        <span>Invalid</span>
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div *ngIf="formType ==='E'">
                                <mat-label>Oxygen Permeability at 35°C</mat-label>
                                <mat-form-field>
                                    <input matInput formControlName="oxygenPermeability35"> 
                                </mat-form-field>
                            </div>
                            <div *ngIf="formType ==='E'">
                                <mat-label>Before and After Modification</mat-label>
                                <mat-form-field>
                                    <input matInput formControlName="oxygenPermeability"> 
                                </mat-form-field>
                            </div>
                            <div *ngIf="formType ==='E'">
                                <mat-label>Mean value ± Standard deviation</mat-label>
                                <mat-form-field>
                                    <input matInput formControlName="oxygenPermeabilityMeanValue"> 
                                    <mat-error *ngIf="this.editFieldsForm.get('oxygenPermeabilityMeanValue')?.invalid && this.editFieldsForm.get('oxygenPermeabilityMeanValue')?.touched">
                                        <span>Invalid</span>
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div *ngIf="formType ==='E'">
                                <mat-label>Number of Measurements</mat-label>
                                <mat-form-field>
                                    <input matInput formControlName="oxygenPermeabilityMeasurement"> 
                                    <mat-error *ngIf="this.editFieldsForm.get('oxygenPermeabilityMeasurement')?.invalid && this.editFieldsForm.get('oxygenPermeabilityMeasurement')?.touched">
                                        <span>Invalid</span>
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div *ngIf="formType ==='E'">
                                <mat-label>Method Used for Oxygen Permeability</mat-label>
                                <mat-form-field>
                                    <input matInput formControlName="oxygenPermeabilityMethod"> 
                                </mat-form-field>
                            </div>
                            <div class="full-width-left">
                                <mat-label>Trademark(s) <span class="red-clr"> *</span></mat-label>
                                <mat-form-field>
                                    <input matInput formControlName="trademark"> 
                                </mat-form-field>
                            </div>
                            <div *ngIf="('A,B,C,D,F').includes(formType)" class="full-width-left">
                                <mat-label>Trivial Name(s)</mat-label>
                                <mat-form-field>
                                    <input matInput formControlName="trivialName"> 
                                </mat-form-field>
                            </div>
                            <div class="full-width-left">
                                <mat-label>Manufacturer(s) <span class="red-clr"> *</span></mat-label>
                                <mat-form-field>
                                    <input matInput formControlName="manufacturer"> 
                                </mat-form-field>
                            </div>
                            <div *ngIf="('A,B,C,F').includes(formType)" class="full-width-left">
                                <mat-label>Principal Therapeutic Use(s) <span class="red-clr"> *</span></mat-label>
                                <mat-form-field>
                                    <input matInput formControlName="principalTheraUse"> 
                                </mat-form-field>
                            </div>
                            <div *ngIf="('A,B,F').includes(formType)" class="full-width-left">
                                <mat-label>Pharmacologic Action <span class="red-clr"> *</span></mat-label>
                                <mat-form-field>
                                    <input matInput formControlName="pharmaAction"> 
                                </mat-form-field>
                            </div>
                            <div *ngIf="('A,B,F').includes(formType)" class="full-width-left">
                                <mat-label>Does the substance bind to a Receptor, Enzyme, or Other Target <span class="red-clr"> *</span></mat-label>
                                <div class="width-100"> 
                                    <span *ngFor="let item of yesNoList" class="qrtr-width padding-bottom-20">
                                        <input type="radio" id="{{'receptor-'+item}}" [value]="item"
                                            formControlName="bindToReceptor" name="bindToReceptor" > 
                                        <label for="{{'receptor-'+item}}">{{item}}</label>
                                    </span>
                                </div>
                                <div *ngIf="substBindToReceptor === 'Yes'" class="full-width-left">
                                    <mat-label>Substance Binding Information </mat-label>
                                    <mat-form-field>
                                        <input matInput formControlName="bindToReceptorExplanation">  
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="full-width-left">
                                <mat-label>Date Phase 1 clinical trials began (MM/DD/YYYY) <span class="red-clr"> *</span></mat-label>
                                <mat-form-field>
                                    <input matInput formControlName="clinicalTrialDate"> 
                                </mat-form-field>
                            </div>
                            <div *ngIf="('A,B,C,D,F').includes(formType)" class="full-width-left">
                                <mat-label>IND Application Number(s) <span class="red-clr"> *</span></mat-label>
                                <mat-form-field>
                                    <input matInput formControlName="indApplNumber"> 
                                </mat-form-field>
                            </div>
                            <div *ngIf="('A,B,F').includes(formType)" class="full-width-left">
                                <mat-label>INN Submission <span class="red-clr"> *</span></mat-label>
                                <div class="full-width"> 
                                    <span *ngFor="let item of yesNoList" class="qrtr-width padding-bottom-20"> 
                                        <input type="radio" id="{{'innSubmission-'+item}}" [value]="item"
                                            formControlName="innSubmission" name="innSubmission"> 
                                        <label for="{{'innSubmission-'+item}}">{{item}}</label>
                                    </span>
                                </div>
                                <div *ngIf="innSubmissionValue === 'Yes'" class="full-width-left">
                                    <mat-label>WHO / INN Submission Number <span class="red-clr"> *</span></mat-label>
                                    <mat-form-field>
                                        <input matInput formControlName="innSubmissionNumber">  
                                    </mat-form-field>
                                </div>
                                <div *ngIf="innSubmissionValue === 'Yes'" class="full-width-left">
                                    <mat-label>WHO / INN Submission Explanation </mat-label>
                                    <mat-form-field>
                                        <input matInput formControlName="innSubmissionExplanation">  
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                        <div class="width-100"> 
                            <div class="save-btn-div half-width"> 
                                <button aria-label="Save" class="save-btn-cls blue-background width-100" (click)="saveEditSubstanceFields()" [disabled]="disableSaveBtn()">
                                    <span class="save-btn-lbl">Save</span> 
                                </button>
                            </div>
                            <div class="save-btn-div half-width" >
                                <button aria-label="Cancel" class="save-btn-cls orange-background width-100" (click)="cancelEditFields()">
                                    <span class="save-btn-lbl">Cancel</span> 
                                </button>
                            </div>
                        </div>
                        <div class="red-clr">{{noChangeMessage}}</div>
                        </form>
                    </div>
                    
                </div>
            </div>
        </ng-template>

        <ng-template #editApplicantFields>
            <div class="comments-dialog-container">
                <span mat-dialog-title class="sub-header"><h4>Edit Applicant Details</h4></span>  
                <div mat-dialog-content>
                    <div class="user-dialog-sub-container">
                        <form [formGroup]="editApplicantFieldsForm">
                            <div class="edit-fields-div">
                                <div class="full-width padding-right-20">
                                    <mat-label>Lead Applicant <span class="red-clr"> *</span> </mat-label>
                                    <div class="user-selection-action" *ngIf="!selectApplicantEdit">
                                        <mat-form-field> 
                                            <input matInput [value]="applicantName" readonly > 
                                        </mat-form-field>
                                        <span class="padding-left-10 user-selection-action" *ngIf="isOrgAdmin || isUsanAdmin"> 
                                            <button class="bgcolor-white user-name-edit" aria-label="Edit Status"  (click)="openEditApplicantSelection()">
                                                <mat-icon>edit</mat-icon>
                                            </button>
                                        </span>
                                    </div>
                                    <mat-form-field *ngIf="selectApplicantEdit"> 
                                        <mat-select [(value)]="applicantName"  class="user-name-input"
                                            (selectionChange)="selectingApplicant($event.value)"> 
                                            <ng-container  *ngFor="let app of applicantsList">
                                            <mat-option [value]="app" >{{ app.userName }}</mat-option>
                                            </ng-container>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <div class="full-width padding-right-20">
                                    <mat-label>Address <span class="red-clr"> *</span> </mat-label>
                                    <mat-form-field>
                                        <input matInput formControlName="street1" > 
                                    </mat-form-field>
                                </div>
                                <div class="full-width padding-right-20">
                                    <mat-label>Address 2 </mat-label>
                                    <mat-form-field>
                                        <input matInput formControlName="street2" > 
                                    </mat-form-field>
                                </div>
                                <div class="full-width">
                                    <div class="half-width">
                                        <mat-label>City <span class="red-clr"> *</span> </mat-label>
                                        <mat-form-field>
                                            <input matInput formControlName="city" > 
                                        </mat-form-field>
                                    </div>
                                    <div class="half-width">
                                        <mat-label>State <span class="red-clr"> *</span></mat-label>
                                        <mat-form-field *ngIf="displayStatesList">
                                            <mat-select [value]="state" formControlName="state" > 
                                                <mat-option [value]="state.key" *ngFor="let state of states">{{ state.key }}</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                        <mat-form-field *ngIf="!displayStatesList">
                                            <input matInput formControlName="state">
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="full-width">
                                    <div class="half-width">
                                        <mat-label>Zip Code <span class="red-clr"> *</span> </mat-label>
                                        <mat-form-field>
                                            <input matInput formControlName="zipCode"> 
                                        </mat-form-field>
                                    </div>
                                    <div class="half-width">
                                        <mat-label>Country <span class="red-clr"> *</span></mat-label>
                                        <mat-form-field> 
                                            <mat-select [value]="country" formControlName="country" (selectionChange)="selectingCountry($event.value)">
                                                <mat-option [value]="c.key" *ngFor="let c of countries">{{ c.value}}</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="full-width">
                                    <div class="half-width">
                                        <mat-label>Telephone number <span class="red-clr"> *</span></mat-label>
                                        <mat-form-field>
                                            <input matInput formControlName="phone" > 
                                            <mat-error *ngIf="this.editApplicantFieldsForm.get('phone')?.invalid && this.editApplicantFieldsForm.get('phone')?.touched">
                                                <span>Invalid</span>
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                    <div class="half-width">
                                        <mat-label>Telephone type </mat-label>
                                        <mat-form-field> 
                                            <mat-select [value]="phoneType" formControlName="phoneType"> 
                                                <mat-option [value]="item.key" *ngFor="let item of phoneTypes">{{ item.value }} </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="full-width">
                                    <div class="half-width">
                                        <mat-label>Primary Contact First Name <span class="red-clr"> *</span></mat-label>
                                        <mat-form-field>
                                            <input matInput formControlName="contactPersonFirst" > 
                                        </mat-form-field>
                                    </div>
                                    <div class="half-width">
                                        <mat-label>Last Name <span class="red-clr"> *</span></mat-label>
                                        <mat-form-field>
                                            <input matInput formControlName="contactPersonLast" > 
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="full-width">
                                    <div class="half-width">
                                        <mat-label>Preferred Pronoun(s) </mat-label>
                                        <mat-form-field>
                                            <input matInput formControlName="pronoun" > 
                                        </mat-form-field>
                                    </div>
                                    <div class="half-width">
                                        <mat-label>Title </mat-label>
                                        <mat-form-field>
                                            <input matInput formControlName="title" > 
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="full-width padding-right-20">
                                    <mat-label>Email address <span class="red-clr"> *</span> </mat-label>
                                    <mat-form-field>
                                        <input matInput formControlName="emailAddress" > 
                                        <mat-error *ngIf="this.editApplicantFieldsForm.get('emailAddress')?.invalid && this.editApplicantFieldsForm.get('emailAddress')?.touched">
                                            <span>Invalid</span>
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="width-100"> 
                                <div class="save-btn-div half-width"> 
                                    <button aria-label="Save" class="save-btn-cls blue-background width-100" (click)="saveEditApplicantFields()" [disabled]="disableApplicantSaveBtn()">
                                        <span class="save-btn-lbl">Save</span> 
                                    </button>
                                </div>
                                <div class="save-btn-div half-width" >
                                    <button aria-label="Cancel" class="save-btn-cls orange-background width-100" (click)="cancelEditApplicantFields()">
                                        <span class="save-btn-lbl">Cancel</span> 
                                    </button>
                                </div>
                            </div>
                            <div class="red-clr padding-top-15">{{noChangeMessage}}</div>
                        </form>
                    </div>
                </div>
            </div>
        </ng-template>

    </div>
</div>

